import { Component, OnInit, Injector, enableProdMode } from '@angular/core';

import { Platform, AlertController, ToastController } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { Router } from '@angular/router';
import { UtilsService } from './utils/utils.service';
import { ServicesService } from './api/services.service';
import { DataExchangeService } from './utils/dataexchange.service';
import { SwUpdate } from '@angular/service-worker';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {
  public selectedIndex = 0;
  public appPages = [
    {
      title: 'Dashboard',
      url: '/dashboard',
      icon: 'barcode'
    },
    {
      title: 'Reports',
      url: '/reports',
      icon: 'bar-chart'
    },
    {
      title: 'Analytics',
      url: '/health',
      icon: 'shuffle'
    },
    {
      title: 'Settings',
      url: '/settings',
      icon: 'settings'
    },
    {
      title: 'About Us',
      url: '/aboutus',
      icon: 'eye'
    },
    {
      title: 'Logout',
      url: '/login',
      icon: 'enter'
    }
  ];


  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private injector: Injector,
    private utils: UtilsService,
    private services: ServicesService,
    private swUpdate: SwUpdate,
    private dataexchange: DataExchangeService,
    private toastCtrl: ToastController,
    private alertCtrl: AlertController,

  ) {
   

    this.swUpdate.available.subscribe(event => {
      console.log('current version is', event.current);
      console.log('available version is', event.available);
      this.swUpdate.activateUpdate().then(() => {
        console.warn('downloaded');
        document.location.reload();
      });
    });
    this.swUpdate.activated.subscribe(event => {
      console.log('old version was', event.previous);
      console.log('new version is', event.current);
    });

    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();

      let router = this.injector.get(Router);

      this.swUpdate.checkForUpdate();

      if (this.utils.getAppStorage() == null) {
        router.navigate(["login"]);
      } else {
        let key = this.utils.getKey();

        this.dataexchange.authkey = key;

        this.services.getAppVersion().subscribe(
          data => {
            if (data != null) {
              router.navigate(["dashboard"]);
            } else {
              router.navigate(["login"]);
            }
          }
        );
      }
    });
  }

  ngOnInit() {


  }
}
